<template>
  <div v-if="consultant" class="view-roles addedit-role">
    <vx-card class="user-card" :title="$t('labels.personal_details')">
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.date_of_birth') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.date_of_birth">
                  <span>{{ consultant.date_of_birth | only_date_format }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: mt-4 md:mt-0">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.place_of_birth') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.place_of_birth">
                  <span>{{ consultant.place_of_birth }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.nationality') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="nationalityStr">
                  <span>{{ nationalityStr }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="user-card project-detail mt-6 user-card" :title="$t('labels.address')">
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.street1') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.street1">
                  <span>{{ consultant.street1 }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: mt-4 md:mt-0">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.street2') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.street2">
                  <span>{{ consultant.street2 }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.city') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.city">
                  <span>{{ consultant.city }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: mt-4 md:mt-0">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.country') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.country_name">
                  <span>{{ consultant.country_name }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.postal_code') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.postal_code">
                  <span>{{ consultant.postal_code }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="user-card project-detail mt-6" :title="$t('labels.current_status')">
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.rank') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.rank_status">
                  <span>{{ consultant.rank_status }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: mt-4 md:mt-0">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.date_of_joining') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.date_of_joining">
                  <span>{{ consultant.date_of_joining }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="user-card project-detail mt-6" :title="$t('labels.contact_information')">
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.work_number') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.work_mobile_number">
                  <span>{{ consultant.work_mobile_number }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: mt-4 md:mt-0">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.home_number') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.home_telephone_number">
                  <span>{{ consultant.home_telephone_number }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.alternate_number') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.alternate_mobile_number">
                  <span>{{ consultant.alternate_mobile_number }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: mt-4 md:mt-0">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.home_email') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.home_email_address">
                  <span>{{ consultant.home_email_address }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="user-card project-detail mt-6" :title="$t('labels.kin_details')">
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.kin_contact_name') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.kin_contact_name">
                  <span>{{ consultant.kin_contact_name }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: mt-4 md:mt-0">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.kin_mobile_number') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.kin_mobile_number">
                  <span>{{ consultant.kin_mobile_number }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row w-full">
            <div class="vx-col sm: w-full md:w-1/2 mb-4">
              <div class="vx-row mb-0">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.kin_alternate_number') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.kin_alternate_number">
                  <span>{{ consultant.kin_alternate_number }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: mt-4 md:mt-0">
              <div class="vx-row">
                <div class="vx-col sm: w-1/2">
                  <label>{{ $t('labels.kin_email_address') }}:</label>
                </div>
                <div class="vx-col sm: w-1/2" v-if="consultant.kin_email_address">
                  <span>{{ consultant.kin_email_address }}</span>
                </div>
                <div class="vx-col sm: w-1/2" v-else>
                  <span>-</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="this.$router.history.current.name == 'Profile'" class="vx-row justify-center">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-chevron-left"
              class="mr-4 mt-4 back-btn"
              align="center"
              @click="goBack()"
            >{{ $t('labels.back') }}</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      consultant: "",
      nationalityStr: ""
    };
  },

  mounted() {
    this.getUserProfile();

    this.$store.commit("UPDATE_TAB", 1);
  },
  methods: {
    async getUserProfile() {
      let consultantId = "";
      if (this.$store.state.userInfo.type === "A") {
        consultantId = this.$route.params.id;
      } else {
        consultantId = this.$store.state.userInfo.id;
      }
      let response = await this.getHTTPGetResponse(
        "/users/get/" + consultantId
      );
      if (response) {
        let user = response.data.user;
        let consultant = user["consultant_detail"];
        this.consultant = consultant;
        let nationality = [];
        let consultant_nationality = consultant.nationalities;
        consultant_nationality.forEach(element => {
          nationality.push(element.nationality);
        });
        this.nationalityStr = nationality.toString();
        this.port = consultant_nationality;
      }
    },

    goBack() {
      history.back();
    }
  }
};
</script>
<style scoped>
button.login-btn {
  background: rgba(var(--vs-primary), 1) !important;
}

.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}
.view-roles label {
  font-weight: 600;
  font-size: 17px !important;
}
</style>


